import ReactDOM from "react-dom";
import { useState, useRef } from "react";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import styles from "./home.module.css";
import image from "../../assets/images/Screenshot__322_-removebg-preview.svg";
import "./cryptoPrice.css";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import { useParams, NavLink, Link } from "react-router-dom";
import Container from "components/LogIn/Container";
function changeUserInformation(newInfo) {}
const items = [
  { name: "صفحه اصلی", to: "/", exact: true },
  { name: " توئیت ها", to: "/arz" },
  { name: "درباره ما", to: "/sarafi" },
  { name: " بلاگ", to: "/blog" },
  { name: "تماس با ما", to: "/matlab" },
];

export default function HeaderTest() {
  const auth = useContext(WithAuthentication);
  const collapseRef = useRef(null);

  const hideBars = () => {
    collapseRef.current.setAttribute("class", "navbar-collapse collapse");
  };

  // window.onscroll = () => {
  //   if (
  //     !document
  //       .querySelector(".header-container .navbar-toggler")
  //       .classList.contains("collapsed")
  //   ) {
  //     document
  //       .querySelector(".header-container .navbar-toggler")
  //       .classList.add("collapsed");
  //     document
  //       .querySelector(".header-container .navbar-collapse")
  //       .classList.remove("show");
  //   }
  // };
  const { buttonProps, itemProps, isOpen } = useDropdownMenu(5);
  return (
    <>
      <div className="sticky-top header-container" style={{ height: 90 }}>
        <nav
          className="navbar navbar-expand-md navbar-dark  "
          style={{ backgroundColor: "#4e0f8c", padding: "1rem 0px" }}
        >
          <div
            className="container-fluid header-item-container"
            style={{ maxWidth: "100% !important", width: "100p%" }}
          >
            <div className="d-flex">
              <button
                className="navbar-toggler me-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbar"
                aria-controls="navbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div>
                <Link to="/">
                  <img className="logo" src={image} alt="" />
                </Link>
              </div>
            </div>

            {/* حالت موبایل */}
            <div className="d-flex d-md-none mobile-menu-container">
              <div
                className="login login-button-container"
                style={{
                  border: "1px solid #40a058",
                  borderRadius: "7px",
                  padding: "11px",
                  textAlign: "center",
                }}
              >
                <span className="text-decoration-none text-light ">
                  <span
                    className=" size1"
                    data-bs-toggle="modal"
                    data-bs-target="#ModalNumber5"
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      fill="currentColor"
                      className="bi bi-person"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                    </svg>
                  </span>

                  {/* modal */}
                </span>
              </div>
            </div>

            <div
              className="collapse navbar-collapse "
              id="navbar"
              ref={collapseRef}
            >
              <ul className="navbar-nav ms-0 align-items-center">
                {items.map((item) => {
                  return (
                    <li class="nav-item p-3 text-light ">
                      <NavLink
                        onClick={hideBars}
                        to={item.to}
                        data-toggle="collapse"
                        data-target="#navbarCollapse"
                        className={(navData) =>
                          navData.isActive ? "activeLink" : "nav-link "
                        }
                        exact={item.exact || false}
                      >
                        {item.name}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
              {/* حالت دسکتاپ */}

              <div className="d-none d-md-flex ms-auto d-flex">
                {!auth.isLogged ? (
                  <div
                    className="login login-button-container mx-2 d-flex align-items-center"
                    style={{
                      border: "1px solid #FFD31D",
                      borderRadius: "7px",
                      padding: "6px 10px ",
                      textAlign: "center",
                      background: "#FFD31D",
                    }}
                  >
                    <span
                      className="text-decoration-none text-dark "
                      style={{ fontSize: "12px" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={16}
                        height={16}
                        fill="currentColor"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                      </svg>

                      <span
                        className=" size1"
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="modal"
                        data-bs-target="#ModalNumber5"
                      >
                        ورود یا ثبت نام
                      </span>

                      {/* modal */}
                    </span>
                  </div>
                ) : (
                  <>
                    <div
                      className="user-link"
                      style={{ marginRight: "60px", whiteSpace: "nowrap" }}
                    >
                      <NavLink
                        to={`${
                          auth.userInfo.userType == 1
                            ? "/customer-panel/orders"
                            : "/admin-panel/orders"
                        }`}
                        className="nav-link text-white "
                      >
                        {auth.userInfo.fullName == " "
                          ? "کاربر عزیز"
                          : auth.userInfo.fullName}
                      </NavLink>
                    </div>
                    <NavLink
                      to={`/`}
                      className=" "
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        className="user-link exit-button"
                        onClick={auth.logout}
                        style={{ cursor: "pointer" }}
                      >
                        <a className="nav-link text-white">خروج</a>
                      </div>
                    </NavLink>
                  </>
                )}
              </div>
            </div>
          </div>
          {ReactDOM.createPortal(
            <Container changeUserInformation={changeUserInformation} />,
            document.getElementById("modals")
          )}
        </nav>
      </div>
    </>
  );
}
